'use strict';

class Bubble {
    init () {
        this.bubbleShow();
        this.bubbleHide();
        this.bubbleHideForlink();
        this.contactUs();
        this.orderReturn();
        this.leaveFeedback();
    }

    bubbleShow () {
        $(document).on('click', '.js-bubble-open', (e) => {
            e.preventDefault();
            $('.slide-navbar').removeClass('open');
            $('.close-button-menu').trigger('click');
            $('.hamburger').removeClass('active');
            $('.legacy-bubble-chat--tezenis').removeClass('hide');
            $('.bubble-element--tezenis').removeClass('hide');
            $('.js-chat-show').addClass('show');
            $('.overlay-bubble-chat').show();
        }).on('click', (evt) => {
            const clickedOutside = $(evt.target).closest('.bubble-element').length === 0;
            const clickedOutsideMobileMenu = $(evt.target).closest('.js-bubble-container-mobile').length === 0;
            if (clickedOutside && clickedOutsideMobileMenu) {
                $('.legacy-bubble-chat--tezenis').addClass('hide');
                $('.bubble-element--tezenis').addClass('hide');
                $('.js-chat-show').removeClass('show');
                $('.overlay-bubble-chat').hide();
            }
        });
    }

    contactUs () {
        $(document).on('click', '.js-bubble-open-contact-us', (e) => {
            e.preventDefault();
            $('.bubble-element').addClass('footer-links-add');
            $('.js-chat-show').addClass('show');
            $('.overlay-bubble-chat').show();
            $('.botton-bubble').hide();
        });
        $(document).on('click', '.js-bubble-call', (e) => {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
        });
    }

    bubbleHide () {
        $(document).on('click', '.bubble-service-list  li.close-bubble', (e) => {
            e.preventDefault();
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
        });
    }

    bubbleHideForlink () {
        $(document).on('click', '.js-close-bubble', (e) => {
            e.preventDefault();
            $('.bubble-element').removeClass('footer-links-add');
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
            $('.botton-bubble').show();
        });
        $(document).on('click', '.js-web-form-request', (e) => {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
        });
    }

    orderReturn () {
        $(document).on('click', '.js-bubble-return', (e) => {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
        });
    }

    leaveFeedback () {
        $(document).on('click', '.js-bubble-leave-feedback', (e) => {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
        });
    }
}

const bubble = new Bubble();
export default bubble;